import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Persona } from "../../types"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { initialValuesRelazione, validationSchemaRelazione } from "./RelazioneAtlanteCommon"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import ModalDelete from "../../components/ModalDelete"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import FormatoForm from "./RelazioneAtlanteForm"
import { transformErrorForForm } from "../../utils/utils"
import { useRelazioneAtlante, useRelazioneAtlanteDelete, useRelazioneAtlanteUpdate } from "../../hooks/relazioniAtlante"

export default function RelazioniAtlanteUpdate() {
  const updateRelazione = useRelazioneAtlanteUpdate()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: relazione } = useRelazioneAtlante(Number(id))

  const [modalStateDeleteRelazione, modalActionsDeleteRelazione] = useModalTrigger()

  const deleteRelazione = useRelazioneAtlanteDelete()

  const initialValues = useMemo(() => initialValuesRelazione(relazione), [relazione])
  const validationSchema = useMemo(() => validationSchemaRelazione(), [])

  useBreadcrumbs([{ label: "Relazioni Atlante", href: "/atlanti/relazioni" }, { label: "Dettaglio Relazione" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{relazione?.nome || <>&nbsp;</>}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteRelazione.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return updateRelazione.mutateAsync(values as Persona).then(() => {
                navigate(`/atlanti/relazioni/${id}`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6">
                  <FormatoForm />
                </Container>
                <BottomFormFixed url="/atlanti/relazioni" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteRelazione.isOpen}
        onClose={modalActionsDeleteRelazione.close}
        onDelete={() => {
          return deleteRelazione.mutateAsync(relazione?.id).then(() => {
            navigate(`/atlanti/relazioni`)
          })
        }}
        message="Sei sicuro di voler eliminare questa relazione?"
        title="Elimina Relazione Atlante"
      />
    </Layout>
  )
}
